import PouchDB from 'pouchdb';
export class dbPair {
  constructor(
    public local: PouchDB.Database,
    public remote: PouchDB.Database
  ) {}
}
